import documentApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleDocuments';

type ThisApi = ApiDefinition['/documents/{documentId}/internal-data']['PUT'];
type Input = ThisApi['params'] & { data: ThisApi['body'] };

const updateInternalDataForDocument = async ({ data, documentId }: Input): Promise<ThisApi['response']> => {
  const response = await documentApiClient.put(`/documents/${documentId}/internal-data`, data);
  return response.data;
};

export default updateInternalDataForDocument;
